import React, {Component} from 'react';
import {connect} from 'react-redux';
// import Swal from 'sweetalert2';
import {withNamespaces} from 'react-i18next';
import moment from "moment";

import AdminLoginHistoryListing from "./AdminLoginHistoryListing";
import Button from "../../components/Button/Button";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { filterErrorHandler } from '../../hoc/Shared/utility';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSearch, faPen} from '@fortawesome/free-solid-svg-icons'

import { getAdminsLoginHistory } from '../../store/ducks/adminLoginHistory/actions';
// import Select from "../../components/Input/Select/Select";

const initialInputState =
{
    /* form input value */
    username: '',
    ip_address: '',
    admin_login_history_date: '',
    start_date: '',
    end_date: ''
};

let adminData = {};
class AdminLoginHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageShow: (this.props.location.state === undefined) ? "listing" : this.props.location.state.pageShow,

            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: null,
            totalPages: 0,
            totalRecords: 0,

            loading: true,

            data: [],
            
            dropDown: [],

            filter: initialInputState,

            isOpen: false,
            currentAdminId: '',

            permission: []

        }
    }

    fetchData() {
        let availablePage = this.state.activePage;
        if (this.state.totalRecords !== 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            (this.state.activePage >= availablePage) && this.setState({ activePage: availablePage});
        }

        Object.keys(this.state.filter).forEach((val) =>
        {
            // listingArr[val] = this.state.filter[val];
            adminData[val] = ((val==='start_date' || val==='end_date') && this.state.filter[val]!=='') ? moment(this.state.filter[val]).format("YYYY-MM-DD HH:mm:ss") : this.state.filter[val];
        });

        adminData.page = (this.state.activePage >= availablePage) ? availablePage : this.state.activePage;
        adminData.limit = this.state.limit;
        adminData.order = JSON.stringify(this.state.order);
        adminData.username = this.state.filter.username;
        adminData.ip_address = this.state.filter.ip_address;
        adminData.lang_id = this.props.currentLanguageId;
        adminData.country_id = this.props.currentCountryId;

        this.props.getAdminsLoginHistory(adminData);
    }

    componentDidMount() {
        if(this.state.pageShow!=='show')
        {
            this.fetchData();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.permission.length === 0 && this.props.currentPermission !== undefined) {
            // let adminPermission = this.props.currentPermission.filter((item) => item.includes("admin_"));
            this.setState({permission: this.props.currentPermission});
        }

        if (nextProps.admin_login_history_data !== this.props.admin_login_history_data && nextProps.admin_login_history_data !== undefined) {
            if (nextProps.admin_login_history_data.data.responseCode === 200 && nextProps.admin_login_history_data.data.msgType === 'success') {
                this.setState({
                    loading: false,
                    data: nextProps.admin_login_history_data.data.data,
                    totalRecords: nextProps.admin_login_history_data.data.totalRecords,
                    totalPages: nextProps.admin_login_history_data.data.totalPages,
                })
            }
            else {
                this.setState({
                    loading: false,
                    data: [],
                    totalRecords: 0,
                    totalPages: 0,
                    activePage: 1
                }, () => {
                    filterErrorHandler(nextProps.admin_login_history_data.data.message);
                });
            }
        }
        // if (nextProps.delete_admin_result !== this.props.delete_admin_result) {
        //     const { t } = this.props;
        //     Swal.fire({
        //         title: t("global.record-deleted"),
        //         icon: nextProps.delete_admin_result.msgType,
        //         confirmButtonText: t("global.ok"),
        //     }).then((result) => {
        //         if (result.isConfirmed) {
        //             this.fetchData();
        //         }
        //     });
        // }

        // if (nextProps.update_status_admin_result !== this.props.update_status_admin_result) {
        //     const { t } = this.props;
        //     Swal.fire({
        //         title: nextProps.update_status_admin_result.message[0],
        //         icon: nextProps.update_status_admin_result.msgType,
        //         confirmButtonText: t("global.ok"),
        //     })
        //     this.fetchData();
             
        // }

        return true;
    }

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence;

        if (order === "asc") {
            orderSequence = true
        } else {
            orderSequence = false
        }

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;


        this.setState({order: orderArry, loading: true, data: []}, () => {
            this.fetchData();
        });
    }

    actionFormatter = (cell, row) => {
        let viewButton, editButton, output;

        if (this.state.permission.includes("admin_show")) {
        viewButton =
            <Button
                typeButton="button"
                classValue="btn btn-sm btn-white mr-2"
                buttonName={<FontAwesomeIcon icon={faSearch}/>}
                key={`view-${row.Id}`}
                clicked={() => this.changePageHandler('show', row.Id)}
            />;
        }

        if (this.state.permission.includes("admin_update")) {
        editButton =
            <Button
                typeButton="button"
                classValue="btn btn-sm btn-white"
                buttonName={<FontAwesomeIcon icon={faPen}/>}
                key={`edit-${row.Id}`}
                clicked={() => this.changePageHandler('edit', row.Id)}
            />;
        }

        // if (this.state.permission.includes("admin_delete")) {
        // deleteButton =
        //     <Button
        //         typeButton="button"
        //         classValue="btn btn-sm btn-danger mr-2"
        //         clicked={(event) => this.deleteAdminHandler(event, row.Id)}
        //         key={`delete-${row.Id}`}
        //         buttonName={<FontAwesomeIcon icon={faTrash}/>}
        //     />;
        // }
        output = [viewButton, editButton];
        return output;
    }

    onInputChange(event)
    {
      let newFilter = Object.assign({}, this.state.filter);
      newFilter[event.target.id] = event.target.value;

      if(event.target.id==='admin_login_history_date')
        {
            const date = (event.target.value!=='') ? event.target.value.split(" - ") : null;
            newFilter['start_date'] = (date) ? date[0] : '';
            newFilter['end_date'] = (date) ? date[1] : '';
        }

      this.setState({
        filter: newFilter
      })
    }

    refreshHandler = () => 
    {
        this.setState({
          loading: true,
          data: [],
          activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
          order: null
        }, ()=>
        {
          this.fetchData();
        });
    }

    clearHandler = () => 
    {
        this.setState({
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: null,
            filter: initialInputState,
            loading: true,
            data: [],
            page: 1
        }, ()=>
        
        {
          this.fetchData();
        });
    }

    changePageHandler = (page, Id) => {
        this.setState({
            pageShow: page,
            currentAdminId: Id
        });
    }

    pageChangeHandler = (activePage) => {
        this.setState({page: activePage, activePage: activePage, loading: true, data: []}, () => {
            this.fetchData();
        });
    }

    sizePerPageHandler = (limit) => {
        this.setState({limit: limit, loading: true, data: []}, () => {
            this.fetchData();
        });
    }

    postSearchHandler = () => {
        this.setState({loading: true, data: [], activePage: 1}, () => {
            this.fetchData();
        });
    }

    onSearchKeyPressHandler = (event) => {
        //Checking press the enter only perform search action
        if (event.key === "Enter") {
            this.setState({loading: true, data: [], activePage: 1}, () => {
                this.fetchData();
            });
        }
    }

    noFormatter = (cell, row, rowIndex) => {
        //let rowNumber = (this.state.activePage - 1) * this.state.limit + (rowIndex + 1);
        let rowNumber = (this.state.totalRecords - rowIndex - ((this.state.activePage - 1) * this.state.limit))
        return <span>{rowNumber}</span>;
    };

    

    render() {
        const {t} = this.props;
        let rsListing = [];
        const columns = [
            {
                text: t('global.no'),
                dataField: "",
                keyField: "no",
                formatter: this.noFormatter,
                headerStyle: () => {
                    return {width: '60px'};
                }
            },
            {
                text: t('admin-login-history.username'),
                keyField: "username",
                dataField: "admin_username",
                sort: true,
                onSort: this.onSort
            },

            

            // {
            //     text: t('admin.email'),
            //     keyField: "Admin_email",
            //     dataField: "email",
            //     sort: true,
            //     onSort: this.onSort
            // },

            {
                text: t('admin-login-history.ip_address'),
                keyField: "ip_address",
                dataField: "ip_address",
                sort: true,
                onSort: this.onSort
            },

            {
                text: t('admin-login-history.date'),
                dataField: "created_at",
                keyField: "created_at",
                sort: true,
                onSort: this.onSort
            }
        ];

        if (this.state.data) {
          rsListing = this.state.data.map((val, idx) => {
              
              return {
                  no: idx,
                  admin_username: val.admin_username,
                  ip_address: val.ip_address,
                  created_at: val.created_at
              };
          });
      }

        return (
            <Auxiliary>
                {this.state.pageShow === 'listing' &&
                <div>
                    <div className="breadcrumb-header">
                        <div className="my-auto">
                            <div className="d-flex">
                                <h4 className="text-muted mt-1 tx-13 ml-2 mb-0">{t('admin-login-history.title')}</h4>
                            </div>
                        </div>
                    </div>
                    <AdminLoginHistoryListing
                        username={this.state.filter.username}
                        ip_address={this.state.filter.ip_address}
                        admin_login_history_date={this.state.filter.admin_login_history_date}
                        onInputChange={(event) => this.onInputChange(event)}
                        clearHandler={() => this.clearHandler()}
                        refreshHandler={() => this.refreshHandler()}
                        columns={columns}
                        activePage={this.state.activePage}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        data={rsListing}
                        order={this.state.order}
                        pageChangeHandler={this.pageChangeHandler}
                        sizePerPageHandler={this.sizePerPageHandler}
                        postSearchHandler={this.postSearchHandler}
                        searchPressSubmitHandler={(event) => this.onSearchKeyPressHandler(event)}
                        loading={this.state.loading}
                        permission={this.state.permission}

                        /**filter drop down*/
                        changePageHandler={this.changePageHandler}
                    />
                </div>
                }
            </Auxiliary>
        )
    }
};

//Received the response from the redux calling the api response
const mapStateToProps = state => {
    const {adminLoginHistory,currentUser} = state;

    return {
        admin_login_history_data: adminLoginHistory.admin_login_history_data,
        currentPermission: currentUser.data.permission,
        currentCountryId: currentUser.data.country_id,
        currentLanguageId: currentUser.data.language_id,
    }
};

const mapDispatchToProps = {
    getAdminsLoginHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces('translation')(AdminLoginHistory));